import {useLocation, useNavigate, useParams} from "react-router-dom";
import {useState} from "react";
import {RouteHelper} from "../../route/RouteHelper";
import {Helmet} from "react-helmet";
import {
    RaikoBaseContainer, RaikoBreadcrumb, raikoBreadCrumbItemGenerator, RaikoButtonSecondary,
    RaikoFlexFirstChildGrowOne,
    RaikoGridOneColumn
} from "@moeindal/base-raiko-panel-components";
import TabContext from "@mui/lab/TabContext";
import Box from "@mui/material/Box";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import GameBasicInfo from "../../component/gameDetails/gameBasicInfo/GameBasicInfo";
import GameThumbnail from "../../component/gameDetails/gameThumbnail/GameThumbnail";
import GameDescription from "../../component/gameDetails/gameDescription/GameDescription";
import GameSettings from "../../component/gameDetails/gameSettings/GameSettings";
import GameAdmissionSettings from "../../component/gameDetails/gameAdmissionSettings/GameAdmissionSettings";
import GameStages from "../../component/gameDetails/gameStages/GameStages";
import {css} from "@emotion/css";

export default function GameDetails() {
    const {state} = useLocation();
    const {id: gameId = 1} = useParams()

    const [tabSelectedValue, setTabSelectedValue] = useState(gameDetailsTabTypes.basicInfo.id);

    const [gameTitle, setGameTitle] = useState(state && state.title ? state.title : RouteHelper.GameDetails.name);


    function handleChangeTab(event, newValue) {
        setTabSelectedValue(newValue)
    }

    const navigate = useNavigate()


    return (
        <>
            <Helmet><title>{gameTitle}</title></Helmet>
            <RaikoBaseContainer>
                <RaikoGridOneColumn>
                    <RaikoFlexFirstChildGrowOne>
                        <RaikoBreadcrumb breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.Games.name,
                                RouteHelper.Games.globalUrl,
                            ),
                            raikoBreadCrumbItemGenerator(
                                gameTitle,
                                ""
                            )
                        ]}/>
                        <RaikoButtonSecondary
                            label={"بازگشت"}
                            onClick={_ => {
                                navigate(-1)
                            }}
                        />
                    </RaikoFlexFirstChildGrowOne>

                    <TabContext value={tabSelectedValue}>
                        <Box sx={{borderBottom: 1, borderColor: 'divider'}} className={css`overflow-x: hidden`}>
                            <TabList onChange={handleChangeTab} id="default-tab-container" variant="scrollable">
                                <Tab
                                    label={gameDetailsTabTypes.basicInfo.title}
                                    value={gameDetailsTabTypes.basicInfo.id}/>
                                <Tab
                                    label={gameDetailsTabTypes.thumbnail.title}
                                    value={gameDetailsTabTypes.thumbnail.id}/>
                                <Tab
                                    label={gameDetailsTabTypes.stages.title}
                                    value={gameDetailsTabTypes.stages.id}/>
                                <Tab
                                    label={gameDetailsTabTypes.description.title}
                                    value={gameDetailsTabTypes.description.id}/>
                                <Tab
                                    label={gameDetailsTabTypes.settings.title}
                                    value={gameDetailsTabTypes.settings.id}/>
                                <Tab
                                    label={gameDetailsTabTypes.admissionSettings.title}
                                    value={gameDetailsTabTypes.admissionSettings.id}/>
                            </TabList>
                        </Box>
                        <TabPanel value={gameDetailsTabTypes.basicInfo.id}>
                            <GameBasicInfo gameId={gameId}/>
                        </TabPanel>
                        <TabPanel value={gameDetailsTabTypes.thumbnail.id}>
                            <GameThumbnail gameId={gameId}/>
                        </TabPanel>
                        <TabPanel value={gameDetailsTabTypes.stages.id}>
                            <GameStages gameId={gameId} gameTitle={gameTitle}/>
                        </TabPanel>
                        <TabPanel value={gameDetailsTabTypes.description.id}>
                            <GameDescription gameId={gameId}/>
                        </TabPanel>
                        <TabPanel value={gameDetailsTabTypes.settings.id}>
                            <GameSettings gameId={gameId}/>
                        </TabPanel>
                        <TabPanel value={gameDetailsTabTypes.admissionSettings.id}>
                            <GameAdmissionSettings gameId={gameId}/>
                        </TabPanel>

                    </TabContext>

                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>
    )
}
const gameDetailsTabTypes = {
    basicInfo: {
        id: "basicInfo",
        title: "اطلاعات پایه",
    },
    thumbnail: {
        id: "gameThumbnail",
        title: "تصویر شاخص",
    },
    stages: {
        id: "stages",
        title: "مراحل",
    },
    description: {
        id: "gameDescription",
        title: "توضیحات",
    },
    settings: {
        id: "settings",
        title: "تنظیمات"
    },
    admissionSettings: {
        id: "admissionSettings",
        title: "پذیرش",
    },
}